import React from 'react';
import InputPage from './InputPage';
import ConfirmPage from './ConfirmPage';
import ResultPage from './ResultPage';
import ErrorPage from './ErrorPage';

const App = () => (
  [
    <InputPage key="input_container" />,
    <ConfirmPage key="confirm_container" />,
    <ResultPage key="result_container" />,
    <ErrorPage key="error_container" />
  ]
);
export default App;
